import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useOrgAuditLiveUpdates } from "@/features/live-updates/use-org-audit-live-updates";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { authQueryOptions } from "@/services/auth";
import { selectActiveCanViewOrganizationDetailsMemberships } from "@/utils/web-org-redirect";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId",
)({
	beforeLoad: async ({ context, params }) => {
		const [viewAllOrgs, userInfo] = await Promise.all([
			context.queryClient.ensureQueryData(
				authQueryOptions.checkAction({
					name: "ViewAllOrganizations",
					entityType: null,
					entityId: null,
				}),
			),
			context.queryClient.ensureQueryData(authQueryOptions.userInfo()),
		]);

		if (viewAllOrgs) return;

		const canViewThisOrg = selectActiveCanViewOrganizationDetailsMemberships(
			userInfo.organizationUserInfo ?? [],
		).some((membership) => membership.organization?.id === params.orgId);

		if (!canViewThisOrg) {
			throw redirect({ to: "/unauthorized" });
		}
	},
	component: OrgAdminDashboard,
});

function OrgAdminDashboard() {
	const { orgId } = Route.useParams();
	const { t } = useAppTranslation();
	useOrgAuditLiveUpdates(orgId);
	void orgId;
	void t;

	return <Outlet />;
}
